import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Icon } from "@/lib/ui";
import { Loader2 } from "lucide-react";
import Pager from "@/components/Pager";

const LIMIT = 25;

export default function AdminScans() {
  const [data, setData] = useState(null);
  const [skip, setSkip] = useState(0);

  const load = useCallback(() => {
    api.get(`/admin/scans?skip=${skip}&limit=${LIMIT}`).then((r) => setData(r.data.data));
  }, [skip]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display font-black text-3xl tracking-tight">Scan History</h1>
        <p className="text-muted-foreground mt-1">Scan events with device metadata &amp; location where shared.</p>
      </div>
      <div className="rounded-2xl border border-border bg-background overflow-hidden overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground"><tr>
            {["Tag", "Device", "Browser", "Location", "IP", "Time"].map((h) => <th key={h} className="text-left font-semibold px-4 py-3 whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody>
            {data === null ? <tr><td colSpan={6} className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto text-muted-foreground" /></td></tr> :
              data.items.length === 0 ? <tr><td colSpan={6} className="py-16 text-center text-muted-foreground">No scans yet.</td></tr> :
              data.items.map((s) => (
                <tr key={s.id} className="border-t border-border" data-testid="scan-row">
                  <td className="px-4 py-3 font-mono font-semibold whitespace-nowrap">{s.tag_number}</td>
                  <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5"><Icon name={s.device_type === "Mobile" ? "Smartphone" : s.device_type === "Tablet" ? "Tablet" : "Monitor"} className="w-4 h-4" />{s.device_type}</span></td>
                  <td className="px-4 py-3">{s.browser}</td>
                  <td className="px-4 py-3">{s.maps_url ? <a href={s.maps_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-status-found font-semibold"><Icon name="MapPin" className="w-3.5 h-3.5" /> Map</a> : <span className="text-muted-foreground">—</span>}</td>
                  <td className="px-4 py-3 text-muted-foreground font-mono text-xs">{s.ip_address}</td>
                  <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">{new Date(s.created_at).toLocaleString()}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {data && <Pager skip={skip} limit={LIMIT} total={data.total} onPage={setSkip} />}
    </div>
  );
}
